let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8FOfk")).then(() => parcelRequire('1hbfn'));